<template>
  <div>
    <div v-if="!showRewardDetail && !showUploadIdCard">
      <div
        style="line-height: 40px; position: relative"
        class="shinywhite text-center pa-0 white--text primary"
      >
        <div>คะแนนสะสม</div>
        <div style="font-size: 60px">{{ numberFormat(member.points) }}</div>
        <div>คะแนน</div>
        <div
          style="
            position: absolute;
            bottom: 0;
            right: 0;
            font-size: 10px;
            font-size: 11px;
            line-height: 14px;
          "
          class="pr-2 pb-2 text-right"
        >
          <p class="ma-0">คะแนนที่จะหมดอายุ {{ member.points_willexpire }} คะแนน</p>
          <p class="ma-0">
            วันที่หมดอายุ
            {{ moment(member.points_expiredate).add(543, "year").format("DD/MM/YYYY") }}
          </p>
        </div>
      </div>
      <div class="text-center pt-2"><v-icon color="primary">mdi-gift</v-icon> แลกของรางวัล</div>
      <div class="px-2 mt-3 pb-2" style="white-space: nowrap; overflow: auto">
        <v-skeleton-loader
          v-if="categoryloading"
          class="mx-auto"
          max-width="300"
          type="heading"
        ></v-skeleton-loader>
        <div v-else>
          <v-btn
            @click="selectCategory('')"
            class="mr-2"
            rounded
            :outlined="selectedCategory !== ''"
            :color="selectedCategory === '' ? 'primary' : ''"
            >All</v-btn
          >
          <v-btn
            v-for="category in rewardcategory"
            :key="category.id"
            @click="selectCategory(category.id)"
            class="mr-2"
            rounded
            :outlined="selectedCategory !== category.id"
            :color="selectedCategory === category.id ? 'primary' : ''"
            >{{ category.name }}</v-btn
          >
        </div>
      </div>
      <div class="mt-3 px-3">
        <div>
          <v-row v-if="rewardloading">
            <v-col cols="6">
              <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col :key="k" v-for="(reward, k) in filteredrewards" cols="6">
              <v-card @click="selectReward(reward)" style="border-radius: 18px">
                <div class="pa-3">
                  <v-img
                    style="border-radius: 5px"
                    aspect-ratio="1"
                    class="mx-auto"
                    :src="reward.image"
                  ></v-img>
                </div>
                <div
                  :class="member.points < reward.points ? 'grey--text' : 'primary--text'"
                  class="px-3 text-truncate"
                >
                  {{ reward.name }}
                </div>
                <div
                  :class="member.points < reward.points ? 'grey' : 'primary'"
                  class="shinywhite pa-2 white--text text-center"
                  style="font-size: 21px"
                >
                  {{ numberFormat(reward.points) }} คะแนน
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <div v-else-if="showUploadIdCard">
      <UploadIdCard
        @close="
          showRewardDetail = true;
          showUploadIdCard = false;
        "
      ></UploadIdCard>
    </div>
    <div v-else>
      <div>
        <div>
          <v-btn @click="showRewardDetail = false" text color="primary">
            <v-icon>mdi-chevron-left</v-icon>
            กลับ
          </v-btn>
        </div>
        <v-row class="px-3">
          <v-col cols="5" class="px-4">
            <v-img
              style="border-radius: 5px; border: 1px solid #f2f2f2"
              aspect-ratio="1"
              class="mx-auto"
              :src="selectedReward.image"
            ></v-img>
          </v-col>
          <v-col cols="7">
            <div class="pa-1 pt-2">
              <div style="font-weight: 600; font-size: 18px">
                {{ selectedReward.name }}
              </div>

              <div>คงเหลือ : {{ numberFormat(selectedReward.quantity) }}</div>

              <div style="font-size: 27px">ใช้ {{ numberFormat(selectedReward.points) }} คะแนน</div>
            </div>
          </v-col>
          <v-col cols="12">
            <div style="font-size: 14px">
              * ถ้าหากของรางวัลคงเหลือเพียง 1 ชิ้น
              ขอสงวนสิทธิให้กับลูกค้าที่มีการกดยืนยันการแลกของมาก่อนเท่านั้น
            </div>
            <div style="font-size: 18px">
              {{ selectedReward.description }}
            </div></v-col
          >
        </v-row>
      </div>
      <v-divider></v-divider>
      <div class="pa-6">
        <div class="mb-2">ที่อยู่จัดส่ง</div>
        <v-card
          @click="showAddressDialog = true"
          v-if="isDefaultAddress"
          style="border-radius: 12px; color: white; cursor: pointer"
          outlined
          color="#5D91D3"
          dark
          class="pa-2"
        >
          <div>
            <div>{{ address.name }}</div>
            <span class="pr-2">{{ address.address }}</span>
            <span class="pr-2"
              >{{ address.province === "กรุงเทพมหานคร" ? "แขวง" : "ตำบล"
              }}{{ address.subDistrict }}</span
            >

            <span class="pr-2"
              >{{ address.province === "กรุงเทพมหานคร" ? "เขต" : "อำเภอ"
              }}{{ address.district }}</span
            >
            <span class="pr-2">จังหวัด{{ address.province }}</span>
            <span>{{ address.postCode }}</span>

            <br />
            เบอร์โทรศัพท์ {{ address.phoneNumber }}
          </div>
        </v-card>
        <v-btn
          v-else
          @click="showAddressDialog = true"
          style="font-size: 19px"
          block
          color="primary"
          outlined
          >เพิ่มที่อยู่</v-btn
        >
        <v-btn
          :loading="saveloading"
          @click="handleRedeemCode"
          large
          class="mt-5"
          style="font-size: 19px"
          block
          color="primary"
          >แลกของรางวัล</v-btn
        >
      </div>
      <!-- <div class="px-5" style="color: grey">
        <div class="font-weight-bold">รอบการจัดส่งของรางวัล</div>
        <v-divider class="mb-2"></v-divider>
        <div class="mb-2">
          <span class="font-weight-bold">รอบที่ 1 :</span> แลกของวันที่ 15-23
          จัดส่งของรางวัลออกจากบริษัทภายในวันที่ 1-5
        </div>
        <div>
          <span class="font-weight-bold">รอบที่ 2</span> : แลกของวันที่ 24-14
          จัดส่งของรางวัลออกจากบริษัทภายในวันที่ 17-20
        </div>
      </div> -->
    </div>
    <v-dialog fullscreen v-model="showAddressDialog">
      <v-card>
        <reward-address @close="showAddressDialog = false"></reward-address>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showRewardSuccess" width="500px" persistent>
      <v-card v-if="showRewardSuccess">
        <reward-success></reward-success>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RewardAddress from "./RewardAddress.vue";
import RewardSuccess from "./RewardSuccess.vue";
import UploadIdCard from "./UploadIdCard/main.vue";

import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      saveloading: false,
      rewardloading: false,
      categoryloading: false,
      showRewardDetail: false,
      showRewardSuccess: false,
      showDelete: false,
      showAddressDialog: false,
      items: [],
      selectedCategory: "",
      pointWillExpired: 0,
      dateExpired: "2022-01-31",
      showUploadIdCard: false,
    };
  },
  components: {
    RewardAddress,
    RewardSuccess,
    UploadIdCard,
  },
  computed: {
    moment() {
      return moment;
    },
    filteredrewards() {
      var result = this.rewards.sort((a, b) => {
        if (
          (a.points >= this.member.points && b.points >= this.member.points) ||
          (a.points < this.member.points && b.points < this.member.points)
        ) {
          return b.points - a.points;
        } else if (a.points >= this.member.points && b.points < this.member.points) {
          return 1;
        } else if (a.points < this.member.points && b.points >= this.member.points) {
          return -1;
        }
      });
      return result;
    },
    selectedReward() {
      return this.$store.state.selectedReward;
    },
    rewards() {
      return this.$store.state.rewards;
    },
    rewardcategory() {
      return this.$store.state.rewardcategory;
    },
    member() {
      return this.$store.state.member;
    },
    address() {
      return this.$store.state.address.find((el) => el.default);
    },
    isDefaultAddress() {
      return (
        this.$store.state.address &&
        this.$store.state.address.length &&
        this.$store.state.address.some((el) => el.default)
      );
    },
  },
  async mounted() {
    Promise.all([this.getRewardCategory(), this.getReward()]);

    if (this.member && this.member.is_block) {
      this.handleCheckBlockUser();
    }
  },
  methods: {
    async handleRedeemCode() {
      const vm = this;
      try {
        const response = await vm.checkUploadIdcard();
        if (response && response.status === 204) {
          await this.$swal
            .fire({
              icon: "warning",
              html: "คุณยังไม่ได้ทำการแนบบัตรประชาชน<br/>" + "กรุณาแนบบัตรประชาชนเพื่อแลกของรางวัล",
              showCancelButton: true,
              confirmButtonText: "กลับไปแนบ",
              cancelButtonText: " ยกเลิก",
              customClass: "custom-swal",
              reverseButtons: true,
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                vm.showUploadIdCard = true;
                vm.showRewardDetail = false;
              }
            });
        } else {
          vm.redeemcode();
        }
      } catch (error) {}
    },
    redeemcode() {
      if (this.isDefaultAddress) {
        this.$swal
          .fire({
            text: "ยืนยันการแลกของรางวัล ?",
            showCancelButton: true,
          })
          .then((result) => {
            if (result.value) {
              this.saveloading = true;
              var data = {
                userid: this.userid,
                pageid: this.query.pageid,
                memberId: this.member.memberId,
                app: this.query.apptype,
                address: this.address,
                productdetail: this.selectedReward, // {id: …, name: …. } ** id คือ id ของที่แลก, name คือ ชื่อของที่แลก **
                redeemPoint: this.selectedReward.points, // point ที่ใช้แลก
              };

              axios
                .post(this.serverUrl + "toacrm/point-redemtion", data, {
                  headers: {
                    AUTHORIZATION: "Bearer xxx xxx",
                  },
                })
                .then(async (response) => {
                  this.saveloading = false;
                  if (response.data.responsecode == 200) {
                    this.$store.state.member.points -= this.selectedReward.points;
                    this.showRewardSuccess = true;
                  } else {
                    await this.$swal.fire({
                      text: response.data.reason,
                    });
                    if (response.data.responsecode == 400) {
                      this.$liff.closeWindow();
                    }
                  }
                });
            }
          });
      } else {
        this.$swal.fire({
          text: "คุณยังไม่ได้เลือกที่อยู่จัดส่ง กรุณาเลือกที่อยู่จัดส่งก่อนทำรายการ",
        });
      }
    },
    selectCategory(item) {
      this.selectedCategory = item;
      this.getReward();
    },
    selectReward(item) {
      if (this.member.points > item.points) {
        this.$store.state.selectedReward = item;
        this.showRewardDetail = true;
      }
    },
    getReward() {
      return new Promise((resolve) => {
        this.rewardloading = true;
        let params = {
          userId: this.userid,
          pageId: this.query.pageid,
        };

        if (this.selectedCategory) {
          params = { category_id: this.selectedCategory };
        }
        axios
          .get(this.serverUrl + "toacrm/reward-product", {
            params,
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            this.rewardloading = false;
            if (response.data.responsecode == 200) {
              this.$store.state.rewards = response.data.data;
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
              }
            }
            resolve();
          });
      });
    },
    getRewardCategory() {
      return new Promise((resolve) => {
        this.categoryloading = true;
        axios
          .get(this.serverUrl + "toacrm/reward-category", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            this.categoryloading = false;
            if (response.data.responsecode == 200) {
              this.$store.state.rewardcategory = response.data.data;
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
              }
            }
            resolve();
          });
      });
    },
    async checkUploadIdcard() {
      try {
        let data = {
          userid: this.userid,
          pageid: this.query.pageid,
          memberId: this.$store.state.member.memberId,
        };

        const url = `${this.serverUrl}toacrm/api/liff/check-id-card-image`;

        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: data,
        });

        return response;
      } catch (error) {
        await this.$swal.fire({ text: response.data.reason });
        this.$liff.closeWindow();
        console.error(error);
      }
    },
    async handleCheckBlockUser() {
      const vm = this;
      const result = await vm.$swal.fire({
        icon: "error",
        html: "คุณไม่สามารถใช้งานเมนูนี้ได้<br/>" + "กรุณาติดต่อเจ้าหน้าที่",
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: "custom-swal",
        confirmButtonText: "ตกลง",
      });
      if (result.value) {
        vm.$emit("isBlockedUser");
      }
    },
  },
};
</script>

<style lang="scss">
.shinywhite {
  position: relative;
}
.shinywhite::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.288);
  left: 0px;
  top: 0px;
  clip-path: polygon(0% 0%, 20% 0%, 30% 100%, 0% 100%);
}
</style>
